<script setup lang="ts"></script>

<template>
  <span class="toolbar-separator"></span>
</template>

<style scoped lang="postcss">
.toolbar-separator {
  @apply mx-3 hidden h-16 rounded-full bg-light-700 xl:inline-block;
  width: 1px;
}
</style>
